

/**
 * [menus description]
 * @return {[type]} [description]
 */
var menus = function(){

	/**
	 * [shopApp description]
	 * @type {[type]}
	 */
	var menusApp = this;

	/**
	 * [getAttributes description]
	 * @param  {[type]} node [description]
	 * @return {[type]}      [description]
	 */
	var getAttributes = function( node )
	{
		var attributes = {};
		for( var i in node.attributes ) {
			if( node.attributes.hasOwnProperty( i ) ) {
				attributes[node.attributes[i].name] = node.attributes[i].nodeValue;
			}
		}
		return attributes;
	};

	var modal;

	/**
	 * [modalResponse description]
	 * @param  {[type]} response   [description]
	 * @param  {[type]} attributes [description]
	 * @param  {[type]} callbacks  [description]
	 * @return {[type]}            [description]
	 */
	var modalResponse = function( response, attributes, callbacks ){
		if( typeof modal !== 'undefined' ) {
			modal.modal('close');
		}
		modal = $(response);
		modal.modal({
			observeChanges : false,
        	onVisible : function() {
        		var modalObj = $(this);
        		var buttons = $('.ui.button', modalObj);
        		var _token = $('[name="_token"]', modalObj).val();
        		var form = $('.ui.form', modalObj);

        		buttons.each(function(){
        			$(this).click( function(e){
        				var button = $(this);
        				e.preventDefault();
        				if( form.length && button[0].tagName.toLowerCase() === 'button' ) {
			    			var action = form.attr('action');
			    		} else {
			    			var action = $(this).attr('href');
			    		}
	        			callbacks.onSave( $(this), modalObj );
							var ajaxOptions = {
	                        type: 'GET',
	                        async: false,
	                        url: action,
	                        data : $('input, select, textarea', form).not('[name="_token"]').serialize(),
	                        success: function( response ){
	                        	if( $(response)[0].id ) {
	                        		callbacks.onComplete( response, attributes, modal );
	                        	} else {
	                        		modalResponse( response, attributes, callbacks );
	                        	}
	                        },
	                        error: function ( xhr, textstatus, errorThrown ) {
	                        	switch( xhr.status ) {
	                        		case 422 :
	                        			var errors = [];
	                        			/** Validation error */
	                        			var response = JSON.parse( xhr.responseText );
	                        			for( var i in response ) {
	                        				errors.push( response[i][0] );
	                        			}
	                        			modalError( errors, modal );
	                        		break;
	                        		case 403 :
	                        			modalError( ["Request middleware denied this action"], modal );
	                        		break;
	                        		default :
	                        			modalError( ['Unknown error has occurred: ["' + xhr.status + '","' + textstatus + '"]'], modal );
	                        		break;
	                        	}
	                        	callbacks.onError( modalObj, xhr );
	                        }
	                    };

	                    if( form.length ) {
	                    	ajaxOptions.headers = {
	                        	'X-CSRF-TOKEN' : _token
	                        };
	                        ajaxOptions.type = 'POST';
	                    }

	        			$.ajax(ajaxOptions);
	        		});
        		});
				callbacks.onVisible( modalObj );
        	},
        	onHidden : callbacks.onHidden
    	}).modal('show');
	};

	/**
	 * [modalEdit description]
	 * @param  {[type]} _this [description]
	 * @return {[type]}       [description]
	 */
	var modalEdit = function( node, _callbacks )
	{
		_callbacks = _callbacks || {};
		var callbacks = $.extend({
			onVisible : function(){},
			onHidden : function(){},
			onComplete : function(){},
			onError : function(){},
			onSave : function(){},
			onResponse : function(){},
			closeModal : true
		}, _callbacks);

		var attributes = getAttributes(node);
		$.get( attributes.href, function( response ) {
			callbacks.onResponse(response, attributes);
			if( typeof $(response)[0].ownerDocument !== 'undefined' ) {
				modalResponse( response, attributes, callbacks );
			}
		});
	};

	/**
	 * [clickEvent description]
	 * @param  {[type]}   elm      [description]
	 * @param  {Function} callback [description]
	 * @return {[type]}            [description]
	 */
	var clickEvent = function( elm, callback )
	{
		elm.removeEventListener( "click", callback );
		elm.addEventListener( "click", callback );
	};

	/**
	 * [keyUpEvent description]
	 * @param  {[type]}   elm      [description]
	 * @param  {Function} callback [description]
	 * @return {[type]}            [description]
	 */
	var keyUpEvent = function( elm, callback )
	{
		elm.removeEventListener( "keyup", callback );
		elm.addEventListener( "keyup", callback );
	};

	/**
	 * [focusEvent description]
	 * @param  {[type]}   elm      [description]
	 * @param  {Function} callback [description]
	 * @return {[type]}            [description]
	 */
	var focusEvent = function( elm, callback )
	{
		elm.removeEventListener( "focus", callback );
		elm.addEventListener( "focus", callback );
	}

	/**
	 * [select description]
	 * @param  {[type]} selector [description]
	 * @param  {[type]} el       [description]
	 * @return {[type]}          [description]
	 */
	var select = function( selector, el ) {
		if ( ! el ) { el = document; }
		return Array.prototype.slice.call( el.querySelectorAll( selector ) );
	};

	/**
	 * [id description]
	 * @param  {[type]} selector [description]
	 * @param  {[type]} el       [description]
	 * @return {[type]}          [description]
	 */
	var singleSelect = function( selector, el ) {
		if ( ! el ) { el = document; }
		return el.querySelector( selector );
	}


	/**
	 * [modalError description]
	 * @param  {[type]} errors [description]
	 * @param  {[type]} modal  [description]
	 * @return {[type]}        [description]
	 */
	var modalError = function( errors, modal )
	{
		var wrapper = $('<div class="ui error message"><div class="header">There was some errors with your submission</div><ul class="list"></ul></div>');
		errors.forEach(function(error){
			$('<li />').text(error).appendTo( $( 'ul', wrapper ) );
		});
		$('[data-for="error-wrapper"]', modal).html('').append(wrapper);
		modal.modal('refresh');
	};

	/**
	 * [items description]
	 * @return {[type]} [description]
	 */
	this.items = function()
	{

		var sortable;

		/**
		 * [bindMiscModalEvents description]
		 * @param  {[type]} modalObj [description]
		 * @return {[type]}          [description]
		 */
		var bindMiscModalEvents = function( modalObj )
		{
			var forType = $('#for', modalObj);
			var container = $('#type-list', modalObj);
			var route = $('#refresh-list-route', modalObj);
			forType.unbind('change').change(function(){
				$.get( route.val() + '/?type=' + forType.val(), function( response ){
					container.replaceWith( $(response) );
					bindMiscModalEvents();
				});
			});
		};

		/**
		 * [updateMenuItemsRows description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var updateMenuItemsRows = function( model, attributes, modal )
		{
			var row = $('[data-row-id="' + model.id + '"]');
			$( '> div > span:eq(1)', row).text( model.text );
		};

		/**
		 * [addMenuItemsRows description]
		 * @param {[type]} response   [description]
		 * @param {[type]} attributes [description]
		 * @param {[type]} modal      [description]
		 */
		var addMenuItemsRows = function( model, attributes, modal )
		{

			$('.disabled.empty').remove();

			var row = $('<li />')
				.attr('data-row-id', model.id)
				.attr('data-parameters', '[' + model.id + ',0,0]');
			var buttons = $('<div />')
				.addClass('ui item-container small icon basic buttons').appendTo(row);
			var mover = $('<span class="ui button"><i class="align move green icon"></i></span>').appendTo(buttons);
			var text = $('<span class="ui button"></span>').text( model.text ).appendTo(buttons);
			var editButton = $('<a data-for="edit-menu-item" class="ui button"><i class="align edit green icon"></i></a>')
				.attr('data-for-row-id', model.id)
				.attr('href', model.edit_url).appendTo(buttons);
			var deleteButton = $('<a data-for="delete-menu-item" class="ui button"><i class="align trash red icon"></i></a>')
				.attr('data-for-row-id', model.id)
				.attr('href', model.delete_url).appendTo(buttons);


			row.appendTo(sortable);
			bindEvents();
			sortable.data( 'api' ).refresh();

		};

		/**
		 * [editItemHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editItemHandler = function(e)
		{
			e.preventDefault();
			$('.ui.form').addClass('loading');
			modalEdit( this, {
				onVisible : function( modalObj ){
					bindMiscModalEvents( modalObj );
				},
				onComplete : function( response, attributes, modal ){
					modal.modal('hide');
					updateMenuItemsRows( response, attributes, modal );
				},
				onHidden : function(){
					$('.ui.form').removeClass('loading');
				}
			});
		};

		/**
		 * [addItemHandler description]
		 * @param {[type]} e [description]
		 */
		var addItemHandler = function(e)
		{
			e.preventDefault();
			$('.ui.form').addClass('loading');
			modalEdit( this, {
				onVisible : function( modalObj ){
					bindMiscModalEvents( modalObj );
				},
				onComplete : function( response, attributes, modal ){
					modal.modal('hide');
					addMenuItemsRows( response, attributes, modal );
				},
				onHidden : function(){
					$('.ui.form').removeClass('loading');
				}
			});
		};

		/**
		 * [deleteItemHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteItemHandler = function(e)
		{
			e.preventDefault();
			$('.ui.form').addClass('loading');
			modalEdit( this, {
				onResponse : function( response, attributes ){
					$('.ui.form').removeClass('loading');
					$('li[data-row-id="' + response.id + '"]', sortable).fadeOut( 200, function(){
						$(this).remove();
						sortable.data( 'api' ).refresh();
					});
				}
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			clickEvent( singleSelect('[data-for="add-menu-item"]'), addItemHandler );
			select('[data-for="edit-menu-item"]').forEach(function(elm){
				clickEvent( elm, editItemHandler );
			});
			select('[data-for="delete-menu-item"]').forEach(function(elm){
				clickEvent( elm, deleteItemHandler );
			});
		};

		/**
		 * [sortableMenu description]
		 * @return {[type]} [description]
		 */
		var sortableMenu = function()
		{
			sortable = $('.sortable-menu').sortableMenu();
			sortable.bind('dropped', function(){
				bindEvents();
			});
			$('#update-menu').click(function(e){
				$('<input />')
					.attr( 'type', 'hidden' )
					.attr( 'name', 'ordering' )
					.val( sortable.data('serialize') )
					.appendTo( $( '#menu-form' ) );
			});
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
				sortableMenu();
			};
		};
	};

};

jQuery(document).ready( function($){

	if( $('.edit.menu').length ) {
		var app = new menus();
		var item = app.items();
		item.init();
	}

});